@if (!isWebApp()) {
    <div class="header-apollo" [ngClass]="styleHeader$$()">
        @if (
            {
                lastSection: lastSection$ | async,
                direction: direction$ | async,
                categories: categories$ | async,
                isAuthenticated: isAuthenticated$ | async,
                tertiaryPrioritiesLoaded: tertiaryPrioritiesLoaded$ | async
            };
            as data
        ) {
            <header-topbar
                [lastSection]="data.lastSection"
                [direction]="data.direction"
                [categories]="data.categories"
                [isLogged]="data.isAuthenticated"
            ></header-topbar>
        }
    </div>
}
